import React from 'react';

function ChangePassword(props) {
    return (
        <div>
            Change Password
        </div>
    );
}

export default ChangePassword;